<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
      <p class="bread-crumbs">Facturación</p>
      <h2 class="">Facturación</h2>
    </div>
  </div>
  
  <div class="content-block">
    <div class="dx-card responsive-paddings pt-2">
        <!-- Filters -->
        <div class="flex flex-nowrap flex-space-between align-items-center">

          <!---->
          <dx-form [(formData)]="filters" [colCount]="3" labelLocation="top" >
             
              <ng-container>
                <dxi-item dataField="companyId" editorType="dxSelectBox"
                  [editorOptions]="{ displayExpr: 'companyName', valueExpr:'id', items: companies, searchEnabled: true, value: null }">
                  <dxo-label text="Empresa"></dxo-label>
                </dxi-item>
              </ng-container>

              <ng-container>
                <!-- Date Start -->
                <dxi-item dataField="dateStart" dataType="date" [isRequired]="false">
                  <dxo-label text="Fecha Inicio"></dxo-label>
                  <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateStart" (onValueChanged)="getInvoices($event)">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                    </dx-validator>
                  </dx-date-box> 
                </dxi-item>

                <!-- Date End --> 
                <dxi-item dataField="dateEnd" dataType="date" [isRequired]="false">
                  <dxo-label text="Fecha Fin"></dxo-label>
                  <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateEnd" (onValueChanged)="getInvoices($event)">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                    </dx-validator>
                  </dx-date-box>
                </dxi-item>
                
              </ng-container>
              
          </dx-form>
          <div class="flex justify-content-center">
            <dx-button text="Buscar" icon="find" type="default" (onClick)="getInvoices($event)"></dx-button>  
          </div>         
        </div>  
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings pt-2"> 
  
      <!-- Results -->
      <div class="mt-5">
        <dx-data-grid [dataSource]="invoices" [showBorders]="true" [columnAutoWidth]="true">
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
          </dxo-pager>
          <dxi-column dataField="dateCreated" caption="Fecha de fondeo"  dataType="number" cellTemplate="dateTemplate" alignment="center"></dxi-column>
          <dxi-column dataField="companyName" caption="Empresa"  dataType="string" alignment="center"></dxi-column>         
          <dxi-column dataField="Mount" caption="Fondeo"  dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column> 
          <dxi-column dataField="Fees" caption="Comisión"  dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column> 
          <dxi-column dataField="Tax" caption="IVA"  dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>                     
          <dxi-column dataField="Total" caption="Total"  dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column> 
          <dxi-column dataField="idInvoice" caption="Descarga" cellTemplate="DownloadTemplate"></dxi-column>
          <div class="buttoms_downloads" *dxTemplate="let data of 'DownloadTemplate'">
            <div class="pdf">
              <dx-button
                  icon="file"
                  text="PDF"
                  (onClick)="downloadPdfInvoice(data.value)">
              </dx-button>  
            </div>
            <div class="xml">           
              <dx-button
                  icon="exportxlsx"
                  text="XML"
                  (onClick)="downloadXmlInvoice(data.value)">
              </dx-button>
            </div>
          </div> 
          <div *dxTemplate="let d of 'dateTemplate'">
            <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
        </div>  
        </dx-data-grid>
      </div>
    </div>
  </div>